import { Box, Stack, TextField } from '@mui/material';

import SearchIcon from '../../../../../assets/svg/settings/reactivation/magnifyingGlass.svg';

interface SearchUserComponentProps {
  value: string;
  onChangeValue: (value: string) => void;
}
const SearchUserComponent = ({ value, onChangeValue }: SearchUserComponentProps) => {

  return (
    <Stack direction='row' alignItems='center' justifyContent='center' gap={2} sx={{
      border: '1px solid #878787',
      borderRadius: '4px',
      padding: '6px 12px 6px 16px',
    }}>
      <Box component='img' src={SearchIcon} />
      <TextField
        variant="standard"
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        placeholder="Search name or email"
        InputProps={{ disableUnderline: true }}
      />
    </Stack>
  );
};

export default SearchUserComponent;